import { mirrorEasing } from './modifiers/mirror.mjs';
import { reverseEasing } from './modifiers/reverse.mjs';
var createBackIn = function createBackIn() {
  var power = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.525;
  return function (p) {
    return p * p * ((power + 1) * p - power);
  };
};
var backIn = createBackIn();
var backOut = reverseEasing(backIn);
var backInOut = mirrorEasing(backIn);
export { backIn, backInOut, backOut, createBackIn };